module.exports = __webpack_public_path__ + "static/media/Tposition.214918f1.fbx";